import {useRef, useEffect, useState} from "react";
import styles from "@/components/ui/sliders/Slider.module.css";

const Slider = ({min, max, value, onChange}) => {
  const trackRef = useRef();
  const [dragging, setDragging] = useState(false);
  const [draggingMax, setDraggingMax] = useState(false);
  const [minVal, setMinVal] = useState(value[0]);
  const [maxVal, setMaxVal] = useState(value[1]);

  useEffect(() => {
    const handleMove = (e) => {
      // Check if it's a touch event and use the first touch location.
      const isTouch = e.type === 'touchmove';
      const currentPageX = isTouch ? e.touches[0].pageX : e.pageX;

      if (!dragging && !draggingMax) return;
      const track = trackRef.current.getBoundingClientRect();
      const newLeft = currentPageX - track.left;
      let newValue = (newLeft / track.width) * (max - min) + min;
      newValue = Math.round(newValue / 10) * 10; // Round to nearest multiple of 10

      if (dragging) {
        if (newValue < min) {
          setMinVal(min);
          onChange([min, maxVal]);
        } else if (newValue < maxVal) {
          setMinVal(newValue);
          onChange([newValue, maxVal]);
        } else {
          setMinVal(maxVal);
          onChange([maxVal, maxVal]);
        }
      } else if (draggingMax) {
        if (newValue > max) {
          setMaxVal(max);
          onChange([minVal, max]);
        } else if (newValue > minVal) {
          setMaxVal(newValue);
          onChange([minVal, newValue]);
        } else {
          setMaxVal(minVal);
          onChange([minVal, minVal]);
        }
      }
    };

    const handleEnd = () => {
      setDragging(false);
      setDraggingMax(false);
    };

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleEnd);

    // Add touch event listeners for mobile devices
    window.addEventListener('touchmove', handleMove);
    window.addEventListener('touchend', handleEnd);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleEnd);

      // Remove touch event listeners when component unmounts
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('touchend', handleEnd);
    };
  }, [dragging, draggingMax, minVal, maxVal, onChange]);


  useEffect(() => {
    setMinVal(value[0]);
    setMaxVal(value[1]);
  }, [value]);

  return (
    <div className={styles.slider} ref={trackRef}>
      <div className={styles.sliderLine}/>
      <div
        className={styles.sliderRange}
        style={{
          left: `${((minVal - min) / (max - min)) * 100}%`,
          right: `${100 - ((maxVal - min) / (max - min)) * 100}%`,
        }}
      />
      <button
        className={styles.sliderButton}
        style={{left: `${((minVal - min) / (max - min)) * 100}%`}}
        onMouseDown={() => setDragging(true)}
        onTouchStart={() => setDragging(true)}
      >
        {minVal}
      </button>
      <button
        className={styles.sliderButton}
        style={{left: `${((maxVal - min) / (max - min)) * 100}%`}}
        onMouseDown={() => setDraggingMax(true)}
        onTouchStart={() => setDraggingMax(true)}
      >
        {maxVal}
      </button>
    </div>
  );
};

export default Slider;
